import script from "./DemandDayInputGroup.vue?vue&type=script&setup=true&lang=ts"
export * from "./DemandDayInputGroup.vue?vue&type=script&setup=true&lang=ts"

import "./DemandDayInputGroup.vue?vue&type=style&index=0&id=23508fb2&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-23508fb2"]])

export default __exports__